import axios from 'axios';
import {axiosConfig as config} from 'config/axiosConfig';

const {REACT_APP_API} = process.env;
const baseUrl = `${REACT_APP_API}/clients`;

export const getAll = async ({page = '', limit = '', name = '', mail = '', numDocument = ''}) => {
 const {data} = await axios.get(`${baseUrl}/findAll/?page=${page}&limit=${limit}&name=${name}&mail=${mail}&numDocument=${numDocument}`, config) 
 return data
}

export const getVinculedClientsWithDirection = async ({idDireccion, mail = "undefined"}) => {
 if(!mail || mail === "undefined"){
    mail = "undefined"
 }
 const {data} = await axios.get(`${baseUrl}/findVinculedClients/${idDireccion}/${mail}`, config) 
 return data
}

export const desvinculedClient = async ({idDireccion, idCliente}) => {
    const {data} = await axios.get(`${baseUrl}/desvinculedClient/${idDireccion}/${idCliente}`, config) 
    return data
}

export const vinculedClient = async ({idDireccion, idCliente}) => {
    const {data} = await axios.get(`${baseUrl}/vinculedClient/${idDireccion}/${idCliente}`, config) 
    return data
}

export const getVinculedClientsWithEmail = async ({idEmail, numDocument = "undefined"}) => {
 if(!numDocument || numDocument === "undefined"){
    numDocument = "undefined"
 }
 const {data} = await axios.get(`${baseUrl}/findVinculedClientsOfEmail/${idEmail}/${numDocument}`, config) 
 return data
}

export const desvinculedClientOfEmail = async ({idEmail, idCliente}) => {
    const {data} = await axios.get(`${baseUrl}/desvinculedClientOfEmail/${idEmail}/${idCliente}`, config) 
    return data
}

export const vinculedClientToEmail = async ({idEmail, idCliente}) => {
    console.log({
        idEmail,
        idCliente
    })
    const {data} = await axios.get(`${baseUrl}/vinculedClientToEmail/${idEmail}/${idCliente}`, config) 
    return data
}

